/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{_ as t}from"../../../../../../../chunks/tslib.es6.js";import{UniformGroup as o,uniform as i}from"../../GraphShaderModule.js";import{ifElse as s,Float as r}from"../../graph/glsl.js";import{isNan as e}from"./utils.js";class l extends o{getSize(t,o){return s(e(t),o,t.multiply(this.unitValueToPixelsRatio))}}t([i(r)],l.prototype,"unitValueToPixelsRatio",void 0);export{l as VisualVariableSizeUnitValue};
